import { TextField } from 'payload'
import { FieldDefault, FieldWithouType } from '@utils/fields'
import { mergeObjects } from '@utils/objects'

/**
 * Creates a Text Field with autocomplete
 *
 * @param config
 * @returns
 */
export function autocompleteField(config: FieldWithouType<CustomPayloadField<TextField>>): CustomPayloadField<TextField>[] {
  const configDefault: FieldDefault<CustomPayloadField<TextField>> = {
    type: 'text',
  };

  const field: CustomPayloadField<TextField> = mergeObjects(config, configDefault);
  return [ field ];
}
